import SettingTypes from '@/utils/setting-types'
import { platformType } from '@/utils/decor-types'

export default {
  name: 'goods-search',
  label: {
    title: Number(platformType) === 0 ? '商品搜索' : '书籍搜索',
    icon: require('@/assets/icon-component-label_GoodsSearch.png'),
    limit: 2
  },
  sort: 8,
  data: {
    // 显示位置
    position: 'normal',
    // 展示模式
    show_style: 'resident',
    // 框体样式
    frame_style: 'square',
    // 文本位置
    text_position: 'left',
    // frame_height
    frame_height: 80,
    // 上下内边距
    frame_margin: 0,
    // 背景颜色
    background_color: '#f9f9f9',
    // 框体颜色
    frame_color: '#ffffff',
    // 文本颜色
    text_color: '#969799',
    //搜索模式(数悦读)
    search_type: 'ALL'
  },
  settings: {
    position: {
      type: SettingTypes.radio_button,
      label: '显示位置',
      show: () => Number(platformType) === 0,
      options: [
        { label: '正常模式', value: 'normal', icon: 'rb-icon-search-normal' },
        { label: '滚动至顶部固定', value: 'fixed-top', icon: 'rb-icon-search-sticky' }
      ]
    },
    show_style: {
      type: SettingTypes.radio_button,
      label: '展示模式',
      show: (data) => data.position === 'fixed-top' && Number(platformType) === 0,
      options: [
        { label: '常驻模式', value: 'resident', icon: 'rb-icon-search-fixed' },
        { label: '上滑消失下滑出现', value: 'scroll-visible', icon: 'rb-icon-search-scroll' }
      ]
    },
    frame_style: {
      type: SettingTypes.radio_button,
      label: '框体样式',
      show: () => Number(platformType) === 0,
      options: [
        { label: '方形', value: 'square', icon: 'rb-icon-search-square' },
        { label: '圆形', value: 'round', icon: 'rb-icon-search-round' }
      ]
    },
    text_position: {
      type: SettingTypes.radio_button,
      label: '文本位置',
      show: () => Number(platformType) === 0,
      options: [
        { label: '居左', value: 'left', icon: 'rb-icon-align-left' },
        { label: '居中', value: 'center', icon: 'rb-icon-align-center' }
      ]
    },
    frame_height: {
      type: SettingTypes.slider,
      label: '框体高度',
      show: () => Number(platformType) === 0,
      props: {
        min: 56,
        max: 80
      }
    },
    frame_margin: {
      type: SettingTypes.slider,
      label: '上下内边距',
      show: () => Number(platformType) === 0,
      props: {
        min: 0,
        max: 60
      }
    },
    background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#f9f9f9',
      show: () => Number(platformType) === 0
    },
    frame_color: {
      type: SettingTypes.color_picker,
      label: '框体颜色',
      default: '#ffffff',
      show: () => Number(platformType) === 0
    },
    text_color: {
      type: SettingTypes.color_picker,
      label: '文本颜色',
      default: '#969799',
      show: () => Number(platformType) === 0
    },
    search_type: {
      type: SettingTypes.select,
      label: '搜索类型',
      show: () => Number(platformType) === 1,
      options: [
        { label: '全部书籍', value: 'ALL' },
        { label: '电子书', value: 'EBOOK' },
        { label: '有声书', value: 'AUDIOBOOK' },
        { label: '视频', value: 'VIDEO' },
        { label: '书香资讯', value: 'INFORMATION' },
        { label: '花城书房', value: 'FLOWER_HOUSE' },
      ]
    }
  }
}
